import React from 'react'
import PropTypes from 'prop-types'
import {IBuilderPageReference} from 'hec/types/common'

// Project Components
import {ProductItem} from './productItem'
import AddRemovedProduct from './addRemovedProduct'
import MinicartHeader from './minicartHeader'
import MinicartFooter from './minicartFooter'

const MinicartContent = ({minicartData, cartPageRef, checkoutPageRef, splitCTAs}) => {
    const {
        handleRemoveItem,
        productsByItemId,
        isProductsLoading,
        localQuantity,
        handleChangeItemQuantity,
        isCartItemLoading,
        selectedItem,
        productItems,
        isLoading,
        setRemovedProducts,
        totalItems,
        basket,
        approachingDiscounts,
        conditionThreshold,
        adjustedOrderTotal
    } = minicartData

    /********* Rendering  UI **********/
    if (isLoading) {
        return <div>Loading...</div>
    }

    const itemToRender = (productItem, idx) => {
        const {isRemoved, data: productData} = productItem
        if (isRemoved) {
            return (
                <AddRemovedProduct
                    setRemovedProducts={setRemovedProducts}
                    product={productData}
                    data-testid="minicartContent-AddRemovedProduct"
                />
            )
        }
        return (
            <ProductItem
                index={idx}
                handleRemoveItem={handleRemoveItem}
                product={{
                    ...productData,
                    ...(productsByItemId && productsByItemId[productData.itemId]),
                    isProductUnavailable: !isProductsLoading
                        ? !productsByItemId?.[productData.itemId]
                        : undefined,
                    price: productData.price,
                    quantity: localQuantity[productData.itemId]
                        ? localQuantity[productData.itemId]
                        : productData.quantity
                }}
                onItemQuantityChange={handleChangeItemQuantity.bind(this, productData)}
                showLoading={isCartItemLoading && selectedItem?.itemId === productData.itemId}
                data-testid="minicartContent-ProductItem"
            />
        )
    }

    return (
        <>
            <MinicartHeader totalItems={totalItems} data-testid="minicartContent-MinicartHeader" />
            <div className="max-h-[21.25rem] overflow-auto pl-[0.9375rem] pr-[1.5625rem]">
                {productItems?.map((productItem, idx) => (
                    <div
                        key={`${productItem.isRemoved ? 'removed' : 'active'}-${
                            productItem.data.itemId
                        }`}
                    >
                        {itemToRender(productItem, idx)}
                    </div>
                ))}
            </div>
            <MinicartFooter
                productTotal={basket.productTotal}
                orderTotal={adjustedOrderTotal}
                currency={basket.currency}
                cartPageRef={cartPageRef}
                splitCTAs={splitCTAs}
                checkoutPageRef={checkoutPageRef}
                approachingDiscounts={approachingDiscounts}
                conditionThreshold={conditionThreshold}
                data-testid="minicartContent-MinicartFooter"
            />
        </>
    )
}

MinicartContent.propTypes = {
    minicartData: PropTypes.object.isRequired,
    cartPageRef: PropTypes.shape({
        value: PropTypes.shape({
            data: PropTypes.shape({
                isSfraPage: PropTypes.bool,
                url: PropTypes.string
            })
        })
    }),
    checkoutPageRef: IBuilderPageReference,
    splitCTAs: PropTypes.bool
}

export default MinicartContent
